import Axios from "axios";
var LoginService = (function () {
    function LoginService() {
    }
    LoginService.prototype.loginByPwd = function (params) {
        return Axios.post("supplierapi/login/loginbypwd", params);
    };
    LoginService.prototype.loginByCode = function (params) {
        return Axios.post("supplierapi/login/loginbycode", params);
    };
    LoginService.prototype.setPwd = function (params) {
        return Axios.post("supplierapi/login/setpwd", params);
    };
    LoginService.prototype.logout = function () {
        return Axios.get("supplierapi/center/logout");
    };
    LoginService.prototype.getConfig = function (params) {
        return Axios.get("/supplierclientapi/getauthtype", { params: params });
    };
    LoginService.prototype.getOpenedCode = function () {
        return Axios.get("/supplierclientapi/service/get_opened_code");
    };
    LoginService.prototype.getOpenedEdiStatus = function () {
        return Axios.post("/supplierclientapi/supplier_config/detail");
    };
    LoginService.prototype.getNotice = function (params) {
        return Axios.get("/supplierclientapi/notice/system_list", { params: params });
    };
    LoginService.prototype.noticeRemindUpdate = function (params) {
        return Axios.get("/supplierclientapi/notice/update", { params: params });
    };
    LoginService.prototype.getServiceWarning = function () {
        return Axios.get("supplierclientapi/service/warning");
    };
    LoginService.prototype.delayToken = function () {
        return Axios.get("supplierclientapi/account/delay_token");
    };
    LoginService.prototype.virtualLogin = function (params) {
        return Axios.get("/supplierapi/login/virtual_login", { params: params });
    };
    LoginService.prototype.getBannerImage = function () {
        return Axios.get("/supplierclientapi/image_management/pc_login_list");
    };
    LoginService.prototype.getTopList = function () {
        return Axios.get("/supplierclientapi/image_management/pc_top_list");
    };
    LoginService.prototype.getTopRightList = function () {
        return Axios.get("/supplierclientapi/image_management/pc_top_right_list");
    };
    LoginService.prototype.getWechatQrcode = function (params) {
        return Axios.get("/supplierclientapi/get_wx_temporary_code", { params: params });
    };
    LoginService.prototype.getWechatScanResult = function (params) {
        return Axios.get("/supplierclientapi/wx_qrcode_scan_state", { params: params });
    };
    LoginService.prototype.getWechatQrcodeStatus = function (params) {
        return Axios.get("/supplierclientapi/get_wx_qrcode_state", { params: params });
    };
    LoginService.prototype.bindAccmount = function (data) {
        return Axios.post("/supplierclientapi/bind_official_account", data);
    };
    LoginService.prototype.getManagementLandingCustom = function (params) {
        return Axios.post("/supplierclientapi/image_management/landing_custom", params);
    };
    LoginService.createInstance = function () {
        LoginService.getInstance();
    };
    LoginService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    LoginService.prototype.getTemporaryTokenLoginQrcode = function (params) {
        return Axios.get("/supplierclientapi/customer/login_qrcode", { params: params });
    };
    LoginService.prototype.getTemporaryTokenLoginQrcodeScanResult = function (params) {
        return Axios.get("/supplierclientapi/wx_qrcode_scan_state", { params: params });
    };
    LoginService.prototype.getBusinessConfigs = function () {
        return Axios.get("/supplierclientapi/business/configs", {});
    };
    return LoginService;
}());
export default LoginService;
